import { createContext } from 'react';

const BookingContext = createContext({});

export { BookingContext };
